import { ToolTip } from '@delta-defense/b2c-shared-react/components/toolTip/module';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type Props = {
  tooltip?: string
}

export function OptionalTooltip(props: Props): React.JSX.Element | null {
  return props.tooltip ? (
    <div className="d-flex justify-content-end align-items-center">
      <ToolTip
        description={props.tooltip}
        direction="right"
      >
        <FontAwesomeIcon icon={faQuestionCircle} size="1x" className="form-field__tooltip" />
      </ToolTip>
      <span className="form-field__optional">
        <em>Optional</em>
      </span>
    </div>
  ) : null;
}
